<template>
<div class="clearfix">
    <div class="container">
        <el-card class="card">
            <img class="logo" src="/static/image/logo.png"/>
            <div class="item-column">
                <span class="span-hint" v-show="!phone_status">{{phone_hint}}</span>
                <el-input placeholder="请输入手机号" size="medium" v-model="phone" @blur='phoneOnBlur' maxlength=11 @keyup.enter.native="signup" clearable></el-input>
            </div>

            <div class="item-column">
                <span class="span-hint" v-show="!password_status">{{password_hint}}</span>
                <el-input placeholder="字母和数字组合，最少6位" size="medium" v-model="password" @blur='passwordOnBlur' @keyup.enter.native="signup" minlength=6 show-password></el-input>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!repassword_status">{{repassword_hint}}</span>
                <el-input placeholder="请再次输入密码" size="medium" v-model="repassword" @blur='repasswordOnBlur' @keyup.enter.native="signup" minlength=6 show-password></el-input>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!verify_status">{{verify_hint}}</span>
                <div class="item-row">
                    <el-input placeholder="输入验证码" size="medium" v-model="verify_code" @blur='verifyOnBlur' @keyup.enter.native="signup" maxlength=11 clearable></el-input>
                    <el-button class="btn-verify" size="medium" @click="getVerifyCode" type="primary" :loading='vloading' :disabled="verify_disable">{{btn_verify}}</el-button>
                </div>
            </div>
            <div class="item-column">
                <el-button class="btn-confirm" size="medium" type="primary" @click="signup" :loading='loading'>注 册</el-button>
            </div>
            <div class="item-column">
                <span class="span-signup-text">已有账号？  点此<span @click="toLogin"> 登录</span></span>
            </div>
<!--            <div class="item-column">-->
<!--                <span class="span-third-login">第三方账号注册</span>-->
<!--                <img class="img-wx" src="/static/image/ic_wx.png" @click="wxLogin"/>-->
<!--            </div>-->
        </el-card>
    </div>
</div>
</template>
<script>
export default {
    data () {
        return {
            phone_hint:'请输入手机号',
            phone_status:true,
            phone:'',
            verify_hint:'请输入验证码',
            verify_status:true,
            verify_code:'',
            password_hint:'请输入密码',
            password_status:true,
            password:'',
            repassword_hint:'请输入密码',
            repassword_status:true,
            repassword:'',
            btn_verify:'获取验证码',
            verify_disable:false,
            verify_second:60,
            confirm_text:'登 录',
            login_change_text:'密码登录',
            login_type:'verify',   //verify or password
            loading:false,
            vloading:false
        }
    },
    created() {
      var args=utils.getRequest(location.href)
      if(args.hasOwnProperty("code") && !this.utils.isEmptyStr(args.code)){
        console.log(args.code)
        var params = {
          wxCode:args.code,
          type:'pc'
        }
        this.wjtHttp.post(this,'/api/wechat/v1/login',params,false,(res)=>{
            this.vloading = false
            var data = res.data
            if(data.code == 200){
              if(!this.utils.isEmptyStr(data.token)){
                this.$cookies.set('token',data.token,{expires:1})
                this.wjtHttp.get(this,'/api/getInfo',{},false,(res)=>{
                    this.loading = false
                    var infoData = res.data
                    if(infoData.code == 200){
                        this.$store.commit('updateUserInfo',infoData)
                        if(data.pwdNotSet == false){
                            this.$router.replace('/SetPassword')
                        }else{
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            this.$router.replace('/')
                        }
                    }else{
                        this.$message({
                            message:(infoData.msg&&infoData.msg.length > 0)?infoData.msg:'服务异常，请联系管理员',
                            type:'error'
                        })
                    }
                },(err)=>{
                    this.loading = false
                })
              }else{ //绑定手机号
                this.$message({
                    message: '首次登录请绑定手机号码',
                    type: 'info'
                });
                this.$router.replace({
                  path:'/Bind',
                  query:{
                    code:args.code
                  }
                })
              }
            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                    type:'error'
                })
            }
        },(err)=>{
            this.vloading = false
        })
      }
    },
    methods:{
        getVerifyCode(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请先填写手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请先填写正确的手机号',
                    type: 'fail'
                });
                return
            }
            var codeParams = {
                telephone:this.phone,
                phoneMd5:this.$md5(this.phone),
                type:'register'
            }
            this.vloading = true
            this.wjtHttp.get(this,'/api/smsCode',codeParams,false,(res)=>{
                this.vloading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message:'发送成功',
                        type:'success'
                    })
                    this.verify_disable = true
                    clearInterval(this.mInterval)
                    this.mInterval = setInterval(() => {
                        if(this.verify_second == 0){
                            this.verify_disable = false
                            this.verify_second = 60
                            clearInterval(this.mInterval)
                            return
                        }
                        this.verify_second--
                    }, 1000);
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.vloading = false
            })
        },
        phoneOnBlur(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
            }else if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
            }else{
                this.phone_status = true
            }
        },
        verifyOnBlur(){
            if(this.verify_code.length == 0){
                this.verify_status = false
                this.verify_hint='请输入验证码'
            }else{
                this.verify_status = true
            }
        },
        passwordOnBlur(){
            if(this.password.length == 0){
                this.password_status = false
                this.password_hint='请输入密码'
            }else if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.password_status = false
                this.password_hint = '密码须为字母和数字组合，最少6位'
            }else{
                this.password_status = true
            }
        },
        repasswordOnBlur(){
            if(this.repassword.length == 0){
                this.repassword_status = false
                this.repassword_hint='请输入确认密码'
            }else if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.repassword)){
                this.repassword_status = false
                this.repassword_hint = '密码须为字母和数字组合，最少6位'
            }else{
                this.repassword_status = true
            }
        },
        loginChangeClick(){
            if(this.login_type == 'verify'){
                this.login_type = 'password'
            }else{
                //忘记密码
                this.$router.push('ResetPassword')
            }
        },
        verifyLoginClick(){
            this.login_type = 'verify'
        },
        toLogin(){
            this.$router.replace('/Login')
        },
        wxLogin(){
          console.log(process.env.APP_ID)
          console.log(process.env.DOMAIN_URL)
          location.href = "https://open.weixin.qq.com/connect/qrconnect?appid="+process.env.APP_ID+"&redirect_uri="+process.env.DOMAIN_URL+"/Signup&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"

        },
        signup(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请输入手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'fail'
                });
                return
            }
            if(this.password.length == 0){
                this.$message({
                    message: '请输入密码',
                    type: 'fail'
                });
                return
            }
            if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.$message({
                    message: '密码须为字母和数字组合，最少6位',
                    type: 'fail'
                });
                return
            }
            if(this.repassword.length == 0){
                this.$message({
                    message: '请输入确认密码',
                    type: 'fail'
                });
                return
            }
            if(this.repassword !== this.password){
                this.$message({
                    message: '两次输入密码不一致',
                    type: 'fail'
                });
                this.repassword = ''
                return
            }
            if(this.verify_code.length == 0){
                this.$message({
                    message: '请输入验证码',
                    type: 'fail'
                });
                return
            }
            var signupParams = {
                username:this.phone,
                code:this.verify_code,
                password:this.password,
                phoneMd5:this.$md5(this.phone),
            }
            this.loading = true
            this.wjtHttp.post(this,'/api/register',signupParams,false,(res)=>{
                this.loading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message: '注册成功',
                        type: 'success'
                    });
                    this.$router.replace('/Login')
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.loading = false
            })
        }
    },
    watch:{
        verify_disable:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        verify_second:function(val){
            if(val < 60){
                this.btn_verify = val + '后重发'
            }
        },
        login_type:function(val){
            if(val == 'verify'){
                this.login_change_text = '密码登录'
            }else{
                this.login_change_text = '忘记密码？'
            }
        }
    }
}
</script>
<style scoped>
    .container{
        margin: 0 auto;
        position: relative;
    }
    .card{
        margin: 30px auto;
        padding: 3% 3%;
        background-color: #fff;
        max-width: 375px;
        width: 100%;
    }
    .logo{
        margin-bottom: 30px;
    }
    .card>img{
        width: 80px;
        height: 80px;
    }
    .span-hint{
        font-size: 16px;
        color: #ce9477;
        padding: 10px 0;
        text-align: left;
    }
    .item-column{
        display: flex;
        flex-direction: column;
        margin-bottom: 32px;
    }
    .item-row{
        display: flex;
        flex-direction: row;
    }
    .btn-verify{
        margin-left: 18px;
    }
    .btn-confirm{
        width: 100%;
        height: 45px;
        margin-top: 42px;
    }
    .span-third-login{
        font-size: 16px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        color: #333333;
    }
    .img-wx{
        width: 36px;
        height: 36px;
        margin-top: 20px;
        position: relative;
        cursor: pointer;
        margin-left: calc(50% - 16px);
    }
    .span-signup-text{
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .span-signup-text>span{
        font-size: 16px;
        color: #FE9400;
        cursor: pointer;
    }
    .logo {
      width: 400px;
      font-size: 49px;
      color: #333333;
      cursor: pointer;
    }
</style>
